var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.classObj },
    [
      _vm.showLogo ? _c("logo", { attrs: { collapse: true } }) : _vm._e(),
      _vm._v("\n  12312\n  "),
      _c(
        "el-scrollbar",
        { attrs: { "wrap-class": "scrollbar-wrapper" } },
        [
          _c(
            "el-menu",
            {
              attrs: {
                "default-active": _vm.activeMenu,
                collapse: true,
                "unique-opened": true,
                "collapse-transition": false,
                mode: "vertical",
              },
            },
            [
              _vm._l(_vm.menuList, function (route) {
                return [
                  route.children && route.children.length
                    ? _c(
                        "el-submenu",
                        {
                          key: route.path,
                          ref: "subMenu",
                          refInFor: true,
                          attrs: {
                            index: route.path,
                            "popper-append-to-body": "",
                            "popper-class":
                              _vm.slideClass +
                              " " +
                              _vm.themeClass +
                              " " +
                              _vm.layoutType,
                          },
                        },
                        [
                          _c(
                            "template",
                            { slot: "title" },
                            [
                              _c("item", {
                                attrs: {
                                  icon: route.icon,
                                  title: _vm.generateTitle(
                                    route.vueName,
                                    route.fullName
                                  ),
                                },
                              }),
                              _c("div", { staticClass: "mainTitle" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.generateTitle(
                                      route.vueName,
                                      route.fullName
                                    )
                                  )
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._l(route.children, function (child) {
                            return _c("sidebar-item", {
                              key: child.enCode,
                              staticClass: "nest-menu",
                              attrs: {
                                "is-nest": true,
                                item: child,
                                "base-path": child.path,
                              },
                            })
                          }),
                        ],
                        2
                      )
                    : [
                        _c(
                          "app-link",
                          { key: route.path, attrs: { to: route.path } },
                          [
                            _c(
                              "el-menu-item",
                              {
                                class: { "submenu-title-noDropdown": true },
                                attrs: { index: route.path },
                              },
                              [
                                _c("item", { attrs: { icon: route.icon } }),
                                _c("div", { staticClass: "mainTitle" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.generateTitle(
                                        route.vueName,
                                        route.fullName
                                      )
                                    )
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                ]
              }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }